import { render, staticRenderFns } from "./IntegrationTeaser.vue?vue&type=template&id=55d0c125&scoped=true&"
import script from "./IntegrationTeaser.vue?vue&type=script&lang=js&"
export * from "./IntegrationTeaser.vue?vue&type=script&lang=js&"
import style0 from "./IntegrationTeaser.vue?vue&type=style&index=0&id=55d0c125&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d0c125",
  null
  
)

export default component.exports